import React from 'react';
import SalesProductivityDashboard from './SalesProductivityDashboard';

function App() {
  return (
    <div className="App">
      <SalesProductivityDashboard />
    </div>
  );
}

export default App;
